
















import { Component, Vue } from "vue-property-decorator";
import gql from "graphql-tag";

import AuthTab, { AuthTabItem } from "@/containers/AuthTab.vue";
import TabBar from "@/basics/tab/TabBar.vue";
import TabItem from "@/basics/tab/TabItem.vue";
import { USER_ME, UserMeData } from "@/graphql/query/user/me";

interface Building {
  id: string;
  token: string;
  name: string;
  group: { id: string; name: string };
}

interface Group {
  id: string;
  name: string;
}

interface Scope {
  resourceId: string;
  resource: string;
  action: string;
}

interface ApolloData {
  building: Building | null;
  groups: Group[];
  scopes: Scope[];
}

@Component({
  components: { AuthTab, TabBar, TabItem },
  apollo: {
    building: {
      query: gql`
        query($id: String!) {
          building(id: $id) {
            id
            token
            name
            group {
              id
              name
            }
            roomFeed(count: 999, page: 1) {
              rooms {
                id
                name
              }
            }
          }
        }
      `,
      variables() {
        const params = this.$apollo.vm.$route.params;
        return {
          id: params.buildingId
        };
      }
    },
    groups: {
      query: gql`
        query {
          groupFeed(count: 99, page: 1) {
            groups {
              id
              name
            }
          }
        }
      `,
      update(data: any) {
        return data.groupFeed.groups;
      }
    },
    groupId: {
      query: USER_ME,
      update(data: UserMeData): string {
        return data.me.group.id;
      }
    },
    scopes: {
      query: USER_ME,
      update(data: UserMeData): Scope[] {
        return data.me.scopes;
      }
    }
  }
})
export default class TabFrame extends Vue implements ApolloData {
  building: Building | null = null;
  groups: Group[] = [];
  scopes: Scope[] = [];
  groupId: string = "";

  get isMyGroup(){
    // 所属と建物のグループが同じならtrue
    return !!(this.groupId! === this.building!.group.id)
  }

  get appTab() {
    return !!this.scopes.find(
      s =>
        s.resource === "Group" &&
        s.resourceId === this.building!.group.id &&
        s.action === "operation"
    );
  }
  get groupTab() {
    return !!this.scopes.find(
      s =>
        s.resource === "Group" &&
        s.resourceId === this.building!.group.id &&
        s.action === "management"
    );
  }

  get tabItems(): AuthTabItem[] {
    if (this.$apollo.loading || !this.building) {
      return [
        {
          name: "building-details",
          title: "部屋リスト",
          scopes: []
        },
        {
          name: "building-app-relation",
          title: "アカウント紐づけ",
          scopes: []
        },        
        {
          name: "building-log",
          title: "操作履歴",
          scopes: []
        },
        {
          name: "building-edit",
          title: "編集",
          scopes: []
        }
      ];
    }

    const operation = [
      {
        resource: "Group",
        resourceId: this.building.group.id,
        action: "operation"
      }
    ];

    const seniorOperation = [
      {
        resource: "Group",
        resourceId: this.building.group.id,
        action: "senior_operation"
      }
    ];

    const management = [
      {
        resource: "Group",
        resourceId: this.building.group.id,
        action: "management"
      }
    ];

    return [
      {
        name: "building-details",
        title: "部屋リスト",
        scopes: operation
      },
      {
        name: "building-app-relation",
        title: "アカウント紐づけ",
        scopes: operation
      },      
      {
        name: "building-log",
        title: "操作履歴",
        scopes: operation
      },
      {
        name: "building-edit",
        title: "編集",
        scopes: management
      }
    ];
  }

  get loading(): boolean {
    return this.$apollo.loading;
  }
}
